import useAuth from '@/auth/useAuth';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { toastSomethingError } from '@/components/ui/toast-content';
import { createTopupSession } from '@/service/payment';
import { zodResolver } from '@hookform/resolvers/zod';
import { ArrowTopRightIcon } from '@radix-ui/react-icons';
import { useForm } from 'react-hook-form';
import { NumericFormat } from 'react-number-format';
import { z } from 'zod';

const Topup = () => {
  const { session } = useAuth();

  const formSchema = z.object({
    amount: z.number().min(5, 'Amount to add must be $5 or more'),
  });
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      amount: undefined,
    },
  });
  const {
    formState: { isSubmitting },
  } = form;

  const onSubmit = async (dataSubmit: z.infer<typeof formSchema>) => {
    try {
      const { data } = await createTopupSession({
        email: session?.user.email || '',
        amount: Math.round(dataSubmit.amount * 100),
      });
      window.open(data?.redirectURL, '_blank', 'noreferrer');
    } catch (e) {
      toastSomethingError();
    }
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          variant={'primary'}
          // className="bg-teal-500 hover:bg-teal-500/90"
          endIcon={<ArrowTopRightIcon />}
        >
          Top-up
        </Button>
      </DialogTrigger>
      <DialogContent>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <DialogHeader>
              <DialogTitle>Add to credit balance.</DialogTitle>
              <DialogDescription>Powered by Stripe.</DialogDescription>
            </DialogHeader>
            <FormField
              control={form.control}
              name="amount"
              render={({ field: { onChange, ...fields } }) => (
                <FormItem className="py-4">
                  <FormLabel>Amount to add</FormLabel>
                  <FormControl>
                    <NumericFormat
                      startIcon={<div>$</div>}
                      customInput={Input}
                      thousandSeparator
                      allowNegative={false}
                      decimalScale={2}
                      {...fields}
                      onValueChange={(v) => onChange(v.floatValue)}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <DialogFooter>
              <Button
                type="submit"
                disabled={isSubmitting}
                endIcon={<ArrowTopRightIcon />}
              >
                Continue
              </Button>
            </DialogFooter>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
};

export default Topup;
